module.exports = __webpack_public_path__ + "img/kinopoisk.42ca4fee.svg";